// extracted by mini-css-extract-plugin
export default {"host":"style_host__9Rwic","negative":"style_negative__K5BWm"};